import { gql } from "@apollo/client";

export const GET_CURRENT_USER = gql`
  query userCurrentGet {
    userCurrentGet {
      id
      email
      username
      messengerType
      messenger
      type
      role
      relatedEntityId
      tenantType
      userLanguage
    }
  }
`;
